
/**
 * 404 error page
 */
export default function Page404() {
  return (
    <div>
      Page not found (404)
    </div>
  ) 
}